<template>
  <div class="tab">
    <div class="tab-container">
      <div v-if="!isLoggedIn" class="tab-login" @click="tabLogin">로그인</div>
      <div v-else class="tab-logout-container">
        <span class="tab-username" @click="tabMypage"
          >{{ username }}님 환영합니다!</span
        >
        <span class="tab-logout" @click="tabLogout">로그아웃</span>
      </div>
    </div>
  </div>
</template>

<script>
import checkSession from "@/js/checkSession.js";

export default {
  components: {},
  data() {
    return {
      username: "",
      isLoggedIn: false,
      loginInfo: {
        id: "",
        pass: "",
      },
    };
  },

  async mounted() {
    /// 세션이 살아있는지 확인해서 처리

    const sessionData = await checkSession.getSession();
    //console.log("tab 세션 데이터 확인:", sessionData);
    //console.log("id 값 확인:", sessionData?.id);

    if (sessionData && sessionData["id"] !== "-1") {
      //console.log("유효한 세션 감지");
      this.username = sessionData["name"];
      this.isLoggedIn = true;
      this.loginInfo.id = "";
      this.loginInfo.pass = "";
    } else {
      // console.log("세션 데이터가 없습니다.");
      /// todo: 로그인 실패 처리
      /// 로그인창으로 route
      //console.log("세션 없음 또는 유효하지 않음");
      this.isLoggedIn = false;
      //return;
    }
  },

  methods: {
    async tabLogin() {
      this.$router.push("/login");
    },

    async tabMypage() {
      this.$router.push("/mypageInfo");
    },

    async tabLogout() {
      await checkSession.logOut();

      this.username = "";
      this.isLoggedIn = false;
      this.loginInfo.id = "";
      this.loginInfo.pass = "";

      alert("로그아웃이 되었습니다.");
      this.$router.push("/");

      // if (this.$route.path.startsWith("/community")) {
      //   alert("로그인 후 이용해주세요");
      //   this.$router.push("/");
      // }
    },
  },
};
</script>

<style>
@import "../assets/css/components/tab.css";
</style>
